import React from 'react';
import { Box, Button, useMediaQuery } from '@mui/material';

interface ShortcutsProps {
	shortcuts: string[];
	onShortcutClick: (shortcutText: string) => void;
	shortcutsEnabled: boolean;
}

const Shortcuts: React.FC<ShortcutsProps> = ({
	shortcuts,
	onShortcutClick,
	shortcutsEnabled,
}) => {
	const isMobile = useMediaQuery('(max-width:600px)');
	return (
		<Box
			sx={{
				overflowX: 'auto',
				display: 'flex',
				marginLeft: '0',
				maxWidth: '100%',
				width: '100%',
			}}
		>
			{shortcuts.map((shortcut, index) => (
				<Button
					key={index}
					variant="outlined"
					onClick={() => onShortcutClick(shortcut)}
					disabled={!shortcutsEnabled}
					style={{
						borderRadius: '8px',
						marginRight: '1em',
						lineHeight:'1.5em',
						padding: '5px 10px 5px 10px',
						backgroundColor: shortcutsEnabled
							? '#e2e2e280'
							: 'lightgray',
						color: shortcutsEnabled ? '#000000' : 'gray',
						cursor: shortcutsEnabled ? 'pointer' : 'not-allowed',
						fontSize: '0.8rem',
						textTransform: 'none',
						minWidth: isMobile ? '60%' : '',
						minHeight:  '100%',
						borderColor: shortcutsEnabled
							? '#cacacac2'
							: 'lightgray',
					}}
				>
					{shortcut}
				</Button>
			))}
		</Box>
	);
};

export default Shortcuts;
